import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { submitVenueSuggestion } from '../api/client';
import styles from './Suggest.module.css';

export default function Suggest() {
  const [searchParams] = useSearchParams();
  const [form, setForm] = useState({
    name: searchParams.get('venue') ?? '',
    address: '',
    website: '',
    notes: '',
    email: '',
  });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  function update(field: string, value: string) {
    setForm(f => ({ ...f, [field]: value }));
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!form.name.trim()) return;
    setStatus('loading');
    try {
      await submitVenueSuggestion(form);
      setStatus('success');
    } catch (err: any) {
      if (err.status === 429) setErrorMsg("Too many submissions. Please try again later.");
      else setErrorMsg("Something went wrong. Please try again.");
      setStatus('error');
    }
  }

  if (status === 'success') {
    return (
      <div className={`container ${styles.page}`}>
        <div className={styles.success}>
          <p className={styles.successIcon}>✓</p>
          <h2>Thanks for the tip!</h2>
          <p>We'll review your suggestion and add the venue if it's a good fit.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`container ${styles.page}`}>
      <h1 className={styles.title}>Suggest a Venue</h1>
      <p className={styles.sub}>Know a bar or small venue doing live music that we're missing? Let us know.</p>

      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.field}>
          <label className={styles.label}>Venue name <span className={styles.required}>*</span></label>
          <input className={styles.input} value={form.name} onChange={e => update('name', e.target.value)} required />
        </div>
        <div className={styles.field}>
          <label className={styles.label}>Address</label>
          <input className={styles.input} value={form.address} onChange={e => update('address', e.target.value)} placeholder="Optional" />
        </div>
        <div className={styles.field}>
          <label className={styles.label}>Website</label>
          <input className={styles.input} type="url" value={form.website} onChange={e => update('website', e.target.value)} placeholder="https://…" />
        </div>
        <div className={styles.field}>
          <label className={styles.label}>Notes</label>
          <textarea className={styles.textarea} value={form.notes} onChange={e => update('notes', e.target.value)} placeholder="Anything helpful…" rows={3} />
        </div>
        <div className={styles.field}>
          <label className={styles.label}>Your email <span className={styles.muted}>(optional, not shared)</span></label>
          <input className={styles.input} type="email" value={form.email} onChange={e => update('email', e.target.value)} />
        </div>

        {status === 'error' && <p className={styles.error}>{errorMsg}</p>}

        <button type="submit" className={styles.btn} disabled={status === 'loading' || !form.name.trim()}>
          {status === 'loading' ? 'Submitting…' : 'Submit Suggestion'}
        </button>
      </form>
    </div>
  );
}
